import { format, parse, isValid } from "date-fns"
import { ISO_DATE_FORMAT } from "../constants/iso-formats"

// TO DO: Move this to a more global location.
export default function extractISODate(date: string | Date): string {
  let dateObject: Date

  if (date instanceof Date) {
    dateObject = date
  } else {
    dateObject = parse(date, ISO_DATE_FORMAT, new Date())

    if (!isValid(dateObject)) {
      throw new Error(`Fecha inválida o formato incorrecto: ${date}`)
    }
  }

  return format(dateObject, ISO_DATE_FORMAT)
}
